export default __webpack_public_path__ + "static/linear-live-typing-8c842b5e9c057002583977708bcb1c94.png";